import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/admin/layout/Layout';
import UserApp from './UserApp';

// Admin Components
import Dashboard from './AdminPanel/Dashboard/Dashboard';
import Kamati from './AdminPanel/kamati/Kamati';
import Wageni from './AdminPanel/wageni/Wageni';
import Payments from './AdminPanel/Payment-History/Payment-History.js';
import Waalikwa from './AdminPanel/waalikwa/Waalikwa';
import Groups from './AdminPanel/groups/Groups';
import Bajeti from './AdminPanel/bajeti/Bajeti';
import Michango from './AdminPanel/michango/Michango';
import Takwimu from './AdminPanel/takwimu/Takwimu';
import Picha from './AdminPanel/picha/Picha';
import Ecards from './AdminPanel/ecards/Ecards.js';
import AdminCardDetails from './AdminPanel/ecards/Admin-Card-Details';
import GeneretedWhatAppCard from './AdminPanel/ecards/Generated-WhatsApp-Card';
import CardBundleDetails from './AdminPanel/ecards/Card-Bundle-Details';
import WhatsappCard from './AdminPanel/Whatsapp-Card/Whatsapp-Card';
import PaymentHistory from './AdminPanel/Payment-History/Payment-History';
import SmsHistory from './AdminPanel/Sms-History/Sms-History';
import Settings from './AdminPanel/settings/Settings.js';
import Account_setting from './AdminPanel/settings/Account-Setting';
import SmsTopup from './AdminPanel/Payment-History/Sms-Topup';
import WebsiteTemplates from './AdminPanel/Website-Templates/Website-Templates';

// Component to dynamically set document title for admin routes
const AdminPageTitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase();

    const titles = {
      '/dashboard': 'Dashboard | Harusi Online Admin',
      '/kamati': 'Kamati | Harusi Online Admin',
      '/wageni': 'Wageni | Harusi Online Admin',
      '/payments': 'Malipo | Harusi Online Admin',
      '/waalikwa': 'Waalikwa | Harusi Online Admin',
      '/groups': 'Makundi | Harusi Online Admin',
      '/bajeti': 'Bajeti | Harusi Online Admin',
      '/michango': 'Michango | Harusi Online Admin',
      '/takwimu': 'Takwimu | Harusi Online Admin',
      '/picha': 'Picha | Harusi Online Admin',
      '/ecards': 'E-Cards | Harusi Online Admin',
      '/generated-whatsapp-card': 'WhatsApp Cards Zilizotengenezwa | Harusi Online Admin',
      '/whatsapp-card': 'WhatsApp Card | Harusi Online Admin',
      '/payment-history': 'Kumbukumbu za Malipo | Harusi Online Admin',
      '/sms-history': 'Kumbukumbu za SMS | Harusi Online Admin',
      '/settings': 'Mipangilio | Harusi Online Admin',
      '/account-setting': 'Mipangilio ya Akaunti | Harusi Online Admin',
      '/sms-topup': 'Ongeza SMS & WhatsApp Credits | Harusi Online Admin',
      '/website-templates': 'Website Templates | Harusi Online Admin',
    };

    if (titles[path]) {
      document.title = titles[path];
    } else if (path.startsWith('/ecards/')) {
      document.title = 'Taarifa za E-Card | Harusi Online Admin';
    } else if (path.startsWith('/generated-whatsapp-card/')) {
      document.title = 'Generated WhatsApp Cards | Harusi Online Admin';
    }
  }, [location]);

  return null;
};

function AdminApp() {
  return (
    <>
      <AdminPageTitleManager />
      <Routes>
        <Route
          element={
            <ProtectedRoute adminOnly={true}>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<div className="admin-layout"><div className="main-content"><Dashboard /></div></div>} />
          <Route path="kamati" element={<div className="admin-layout"><div className="main-content"><Kamati /></div></div>} />
          <Route path="wageni" element={<div className="admin-layout"><div className="main-content"><Wageni /></div></div>} />
          <Route path="payments" element={<div className="admin-layout"><div className="main-content"><Payments /></div></div>} />
          <Route path="waalikwa" element={<div className="admin-layout"><div className="main-content"><Waalikwa /></div></div>} />
          <Route path="groups" element={<div className="admin-layout"><div className="main-content"><Groups /></div></div>} />
          <Route path="bajeti" element={<div className="admin-layout"><div className="main-content"><Bajeti /></div></div>} />
          <Route path="michango" element={<div className="admin-layout"><div className="main-content"><Michango /></div></div>} />
          <Route path="takwimu" element={<div className="admin-layout"><div className="main-content"><Takwimu /></div></div>} />
          <Route path="picha" element={<div className="admin-layout"><div className="main-content"><Picha /></div></div>} />
          <Route path="ecards" element={<div className="admin-layout"><div className="main-content"><Ecards /></div></div>} />
          <Route path="ecards/:id" element={<div className="admin-layout"><div className="main-content"><AdminCardDetails /></div></div>} />
          <Route path="Generated-WhatsApp-Card" element={<div className="admin-layout"><div className="main-content"><GeneretedWhatAppCard /></div></div>} />
          <Route path="Generated-WhatsApp-Card/:batchId" element={<div className="admin-layout"><div className="main-content"><CardBundleDetails /></div></div>} />
          <Route path="whatsapp-card" element={<div className="admin-layout"><div className="main-content"><WhatsappCard /></div></div>} />
          <Route path="payment-history" element={<div className="admin-layout"><div className="main-content"><PaymentHistory /></div></div>} />
          <Route path="sms-history" element={<div className="admin-layout"><div className="main-content"><SmsHistory /></div></div>} />
          <Route path="settings" element={<div className="admin-layout"><div className="main-content"><Settings /></div></div>} />
          <Route path="account-setting" element={<div className="admin-layout"><div className="main-content"><Account_setting /></div></div>} />
          <Route path="sms-topup" element={<div className="admin-layout"><div className="main-content"><SmsTopup /></div></div>} />
          <Route path="website-templates" element={<div className="admin-layout"><div className="main-content"><WebsiteTemplates /></div></div>} />
        </Route>

        {/* Fallback to UserApp for all public routes */}
        <Route path="*" element={<UserApp />} />
      </Routes>
    </>
  );
}

export default AdminApp;